<template>
  <div>
    <!-- {{accounts}} -->
    <div class="mb-5">
      <span class="table__search-input-wrapper">
        <input type="text" v-model="search" class="table__search-input" placeholder="Search..." />
        <svg class="mx-2" width="10" height="5" viewBox="0 0 10 5" fill="none">
          <path d="M0 0L5 5L10 0H0Z" fill="black" />
        </svg>
        <search-icon />
      </span>
      <span class="float-right">
        <Button @click="addAccountModal = true" text="+ New Account" />
      </span>
    </div>
    <b-table-simple head-row-variant="primary" responsive="sm">
      <b-thead>
        <b-tr class="" style="background-color: #f2f7fc">
          <b-th>Account Name</b-th>
          <b-th>Bank Name</b-th>
          <b-th>Account Number</b-th>
          <b-th>Status</b-th>
          <b-th></b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="acc in filterAccounts" :key="acc.number">
          <b-td style="border-bottom: solid 3px #dae8f6; background: white">{{ acc.account_name }}
            <div>
              <!-- <span style="color: #fcc210; font-size: 12px">Default</span> -->
            </div>
          </b-td>
          <b-td style="border-bottom: solid 3px #dae8f6; background: white">{{
            acc.bank_name
            }}</b-td>
          <b-td style="border-bottom: solid 3px #dae8f6; background: white">
            {{ acc.account_number }}
          </b-td>
          <b-td style="border-bottom: solid 3px #dae8f6; background: white">
            <span class="text-success" v-if="acc.is_active">
              {{ acc.is_active ? "Active" : "Inactive" }}
            </span>
            <span class="text-danger" v-else>
              {{ acc.is_active ? "Active" : "Inactive" }}
            </span>
          </b-td>
          <b-td style="
              border-bottom: solid 3px #dae8f6;
              background: white;
              align-item: center;
            ">
            <span>
              <el-dropdown>
                <button>
                  <span>
                    <img src="@/assets/images/icons/more.png" alt="" />
                  </span>
                </button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item><span @click="selectAccount(acc)">View & Edit</span>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="acc.is_active === true"><span
                      @click="deactivateAccount(acc)">Deactivate</span>
                  </el-dropdown-item>
                  <el-dropdown-item v-else><span @click="activateAccount(acc)">Activate</span>
                  </el-dropdown-item>
                  <el-dropdown-item><span @click="deleteAccount(acc)">Delete</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown></span></b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
    <div v-if="accounts == '' && loading === false" class="pa-5 my-5">
      <empty-state class="px-5" description="" />
    </div>
    <loader v-if="loading" />

    <!-- Edit Account Modal -->
    <modal title="Add Collection Account" @close-modal="editAccountModal = false" :showModal="editAccountModal"
      id="addAccount" width="500">
      <form @submit.prevent="editAccount">
        <div class="container">
          <div class="row mt-3 justify-content-center">
            <div class="col-md-12">
              <span class="">
                <label for="business-name" style="font-weight: 400; font-size: 16px">Business Name
                </label>
                <base-input style="width: 460px; color: #000" class="text-center" type="text" disabled
                  :value="businessName.companyname" name="pickup-location" placeholder="--Auto-generated from profile--"
                  required="true" error="Enter a pickup location" width="100">
                </base-input>
              </span>
            </div>
          </div>
          <div>
            <div class="row mt-3 justify-content-center">
              <div class="col-md-12">
                <span class="">
                  <label for="banks" style="font-weight: 400; font-size: 16px">Bank Name:
                  </label>
                  <b-form-select style="width: 460px" v-model="selectedAccount.bank_name"
                    :options="banks"></b-form-select>
                </span>
              </div>
            </div>
            <div class="row mt-3 justify-content-center">
              <div class="col-md-12">
                <span class="">
                  <label for="banks" style="font-weight: 400; font-size: 16px">Account Number:
                  </label>
                  <base-input :options="banks" v-model="selectedAccount.account_number" name="banks"
                    style="width: 460px" type="number" placeholder="--Account Number--" required="true"
                    error="Account Number Cannot Be Blank" width="100">
                  </base-input>
                </span>
              </div>
            </div>
            <div class="row mt-3 justify-content-center">
              <div class="col-md-12">
                <span class="">
                  <label for="banks" style="font-weight: 400; font-size: 16px">Account Name:
                  </label>
                  <base-input v-model="selectedAccount.account_name" name="banks" style="width: 460px" type="Name"
                    placeholder="--Autoloaded--" required="true" error="Account Name Cannot Be Blank" width="100">
                  </base-input>
                </span>
                <!-- <div style=" width: 460px;
font size: 14px; font-weight:400">
                  <span class="float-left">skrep group of bank</span>
                  <span class="float-right"><img src="@/assets/images/icons/heavy-check-mark.svg" alt="" /></span>
                </div>
                <div style=" width: 460px;
font size: 14px; font-weight:400">
                  <span class="float-left">Name does not match</span>
                  <span class="float-right"><svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                      <path fill="red"
                        d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                    </svg></span>
                </div> -->
              </div>
            </div>
          </div>

          <div class="row my-4"></div>
          <div class="row">
            <div class="col">
              <Button text="Save" type="submit" class="float-right" />
            </div>
          </div>
        </div>
      </form>
    </modal>
    <!-- Add Account Modal -->
    <modal title="Add Collection Account" @close-modal="addAccountModal = false" :showModal="addAccountModal"
      id="addAccount" width="500">
      <form @submit.prevent="createAccount">
        <div class="container">
          <div class="row mt-3 justify-content-center">
            <div class="col-md-12">
              <span class="">
                <label for="business-name" style="font-weight: 400; font-size: 16px">Business Name
                </label>
                <base-input style="width: 460px; color: #000" class="text-center" type="text" disabled
                  :value="businessName.companyname" name="pickup-location" placeholder="--Auto-generated from profile--"
                  required="true" error="Enter a pickup location" width="100">
                </base-input>
              </span>
            </div>
          </div>
          <div v-for="(acc, i) in newAccounts" :key="i">
            <div class="row mt-3 justify-content-center">
              <div class="col-md-12">
                <span class="">
                  <label for="banks" style="font-weight: 400; font-size: 16px">Bank Name:
                  </label>
                  <b-form-select style="width: 460px" v-model="acc.bank_name" :options="banks"></b-form-select>
                </span>
              </div>
            </div>
            <div class="row mt-3 justify-content-center">
              <div class="col-md-12">
                <span class="">
                  <label for="banks" style="font-weight: 400; font-size: 16px">Account Number:
                  </label>
                  <base-input :options="banks" v-model="acc.account_number" @input="accountNumberEvent($event, i)"
                    name="banks" style="width: 460px" type="number" placeholder="--Account Number--" required="true"
                    error="Account Number Cannot Be Blank" width="100">
                  </base-input>
                </span>
              </div>
            </div>
            <div class="row mt-3 justify-content-center">
              <div class="col-md-12">
                <span class="">
                  <label for="banks" style="font-weight: 400; font-size: 16px">Account Name:
                  </label>
                  <base-input v-model="acc.account_name" name="banks" style="width: 460px" type="Name" :disabled="true"
                    placeholder="--Autoloaded--" required="true" error="Account Name Cannot Be Blank" width="100">
                  </base-input>
                </span>
                <!-- <div
                  style=" width: 460px;
font size: 14px; font-weight:400"
                >
                  <span class="float-left"
                    >name of account should appear here</span
                  >
                  <span class="float-right"
                    ><img
                      src="@/assets/images/icons/heavy-check-mark.svg"
                      alt=""
                  /></span>
                </div>
                <div
                  style=" width: 460px;
font size: 14px; font-weight:400"
                >
                  <span class="float-left">Name does not match</span>
                  <span class="float-right"
                    ><svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                      <path
                        fill="red"
                        d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
                      /></svg
                  ></span>
                </div> -->
              </div>
            </div>
            <div v-if="newAccounts.length > 1" class="row mt-3 justify-content-center">
              <div class="col">
                <Button class="float-right" @click="removeAccount(i)" text="- Remove Account"
                  style="color: red; font size: 14px; font-weight:600" background="white" />
              </div>
            </div>
          </div>

          <div class="row my-4">
            <div class="col">
              <Button @click="addNewAccount" text="+ Add Account"
                style="color: #fcc210; font size: 14px; font-weight:600" background="white" />
            </div>
          </div>
          <div class="row">
            <div class="col">
              <Button text="Save" type="submit" class="float-right" />
            </div>
          </div>
        </div>
      </form>
    </modal>
    <DeleteAccountModal :showModal="showDelete" @close-modal="showDelete = false" :itemToDelete="activeAcc"
      :refetch="getAccounts" />
    <pagination :total="totalAccounts" :pageNumber="pageNumber" @pageNumber="setNumDisplaySettlement"
      @pageSize="setPageDisplaySettlement" />
  </div>
</template>

<script>
import Modal from "../Modal.vue";
import Pagination from "@/components/UI/pagination";
import axios from "axios";
import Button from "@/components/UI/BaseButton.vue";
import DeleteAccountModal from "./modal/DeleteAccountModal.vue";

export default {
  components: {
    Button,
    Pagination,
    // Tooltip,
    DeleteAccountModal,
    Modal,
  },
  data() {
    return {
      showDelete: false,
      loading: false,
      totalAccounts: 1,
      pageNumber: 1,
      pageSize: 10,
      businessName: "",
      selectedAccount: [],
      billingSettings: [],
      showMore: false,
      search: "",
      allSelected: false,
      pagin: "",
      indeterminate: false,
      editAccountModal: false,
      addAccountModal: false,
      activeEdit: null,
      activeAcc: {},
      newAccounts: [
        {
          bank_name: "",
          account_number: "",
          account_name: "",
        },
      ],
      accounts: [],
      bankFullInfo: [],
      banks: [],
    };
  },
  mounted() {
    this.getBanks();
    this.businessName = JSON.parse(localStorage.getItem("organizationDetails"));
    this.getAccounts();
    this.getPagination();
  },
  methods: {
    accountNumberEvent(event, id) {
      this.newAccounts[id].account_name = null
      this.newAccounts[id].account_number = event;
      this.activeEdit = id;
      if (!this.newAccounts[id].bank_name) return;
      const activeBank = this.bankFullInfo.find((item) => item.name == this.newAccounts[id].bank_name);
      if (this.newAccounts[id].account_number && activeBank.code && this.newAccounts[id].account_number.length > 9) {
        this.getAccountName(this.newAccounts[id].account_number, activeBank.code);
      }
    },
    setNumDisplaySettlement(val) {
      this.pageNumber = val;
    },
    setPageDisplaySettlement(val) {
      this.pageSize = val;
    },
    perPageSize(pageSize) {
      this.pageSize = pageSize;
    },
    addNewAccount() {
      this.newAccounts.push({
        bank_name: "",
        account_number: "",
        account_name: "",
      });
    },
    removeAccount(i) {
      this.newAccounts.splice(i, 1);
    },
    async getAccountName(acctNo, code) {
      try {
        let res = await this.$_getAccountInfo({
          accountNumber: acctNo,
          bankCode: code
        })
        this.newAccounts[this.activeEdit].account_name = res?.data?.data.account_name
      } catch (error) {
        console.log(error)
      }
    },
    selectAccount(account) {
      this.editAccountModal = true;
      this.selectedAccount = { ...account };
    },
    async deactivateAccount(acc) {
      try {
        let id = acc.id;
        acc.is_active = false;

        await this.$_editAccount(acc, id);
        this.getAccounts();
        this.editAccountModal = false;
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    async activateAccount(acc) {
      try {
        let id = acc.id;
        acc.is_active = true;

        await this.$_editAccount(acc, id);
        this.getAccounts();
        this.editAccountModal = false;
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    async editAccount() {
      try {
        let id = this.selectedAccount.id;

        await this.$_editAccount(this.selectedAccount, id);
        this.getAccounts();
        this.editAccountModal = false;
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    async createAccount() {
      try {
        let orgId = localStorage.getItem("organizationId");
        let userId = localStorage.getItem("userId");
        let accountPayload = {
          orgId: orgId,
          userId: userId,
          accounts: this.newAccounts,
        };
        await this.$_createAccount(accountPayload);
        this.getAccounts();
        (this.newAccounts = [
          {
            bank_name: "",
            account_number: "",
            account_name: "",
          },
        ]),
          (this.addAccountModal = false);
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    async getBanks() {
      try {
        const response = await axios.get("https://api.paystack.co/bank")
        this.banks = response.data.data.map((bank) => bank.name)
        this.bankFullInfo = response.data.data;
      } catch (error) {
        this.handleError(error);
        this.loading = false;
        console.log(error);
      }
    },
    async deleteAccount(acc) {
      console.log(acc)
      this.activeAcc = acc;
      this.showDelete = true;
    },
    async getAccounts() {
      try {
        this.loading = true;
        let response = await this.$_getAccounts({
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
        });
        // console.log(JSON.stringify(response, null, 2))
        this.accounts = response.data.data.accounts;
        this.totalAccounts = response.data.data.totalCount;
      } catch (error) {
        this.handleError(error);
        this.loading = false;
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    filterAccounts() {
      return this.filterArray(this.accounts, this.search);
    },
  },
  watch: {
    newAccounts(val) {
      console.log(val)
    },
    pageNumber(val) {
      this.pageNumber = val;
      this.getAccounts();
    },
    pageSize(val) {
      this.pageSize = val;
      this.getAccounts();
    },
    estimatedCost(val) {
      this.estimatedCost = val;
    },
    selectedRoute(newValue) {
      // Handle changes in individual flavour checkboxes
      if (newValue.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (newValue.length === this.routes.length) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    },
  },
};
</script>

<style scoped>
.table__search-input-wrapper {
  align-items: center;
  display: inline-flex;
  justify-content: space-between;
  background: #f0f2f1;
  height: 2.25rem;
  width: 380px;
  border-radius: 15px;
  padding: 0 1rem;
  margin-right: 1.5rem;
}

.table__search-input {
  background: transparent;
  color: #343633;
  font-size: 0.9rem;
  width: 100%;
  height: 100%;
}

.table__search-input:focus {
  outline: none;
}

.table__search-input::placeholder {
  color: #343633;
  font-size: 0.9rem;
}

.button {
  border-radius: 15px;
  padding: 0 1rem;
}

@media screen and (max-width: 768px) {
  .table__search-input-wrapper {
    width: 100%;
  }

  .table__btn-wrapper {
    width: 100%;
  }

  .button {
    width: 100%;
    margin-bottom: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
}
</style>
